import(/* webpackMode: "eager" */ "/app/apps/explore/app/(explore)/@mapComponents/[locale]/explore/page.tsx");
